/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { DocumentiAccettazioneForm } from '../model/models';
import { DocumentiDaAccettareDTO } from '../model/models';
import { DocumentoVigenteDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AccettaDocumentiCittadinoRequestParams {
    slug: string;
    documentiAccettazioneForm: DocumentiAccettazioneForm;
}

export interface GetDocumentiDaAccettareCittadinoRequestParams {
    slug: string;
}

export interface GetDocumentiVigentiCittadinoRequestParams {
    slug: string;
}


export interface CittadinoDocumentiDelComuneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Registra l\&#39;accettazione dei documenti del comune.
     * Audience: CITTADINO. Tutto o niente: per ogni documento va indicata la versione corrente e il valore di tutte le spunte; le obbligatorie devono essere vere. Restituisce cio\&#39; che resta da accettare.
     * @endpoint post /api/v1/cittadino/comuni/{slug}/documenti/accettazioni
* @param requestParameters
     */
    accettaDocumentiCittadino(requestParameters: AccettaDocumentiCittadinoRequestParams, extraHttpRequestParams?: any): Observable<DocumentiDaAccettareDTO>;

    /**
     * Documenti del comune ancora da accettare.
     * Audience: CITTADINO. Da accettare &#x3D; documento attivo con versione pubblicata corrente non ancora accettata. Senza documenti pubblicati attivi risponde da_accettare&#x3D;false con lista vuota (mai un errore).
     * @endpoint get /api/v1/cittadino/comuni/{slug}/documenti/da-accettare
* @param requestParameters
     */
    getDocumentiDaAccettareCittadino(requestParameters: GetDocumentiDaAccettareCittadinoRequestParams, extraHttpRequestParams?: any): Observable<DocumentiDaAccettareDTO>;

    /**
     * Documenti vigenti del comune, con la mia ultima accettazione.
     * 
     * @endpoint get /api/v1/cittadino/comuni/{slug}/documenti
* @param requestParameters
     */
    getDocumentiVigentiCittadino(requestParameters: GetDocumentiVigentiCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Array<DocumentoVigenteDTO>>;

}
